import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Affiliates from "./pages/Affiliates";
import AffiliateDetail from "./pages/AffiliateDetail";
import Conversions from "./pages/Conversions";
import ConversionDetail from "./pages/ConversionDetail";
import Products from "./pages/Products";
import Promoters from "./pages/Promoters";
import PromoterDetail from "./pages/PromoterDetail";
import ChangePassword from "./pages/ChangePassword";
import PromoterDashboard from "./pages/portal/PromoterDashboard";
import PromoterCommissions from "./pages/portal/PromoterCommissions";

function Loading() {
  return <div className="loading">Loading…</div>;
}

function homePathFor(user) {
  return user && user.role === "promoter" ? "/portal" : "/";
}

function Protected({ children, roles }) {
  const { user, checking } = useAuth();
  if (checking) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  // Force first-login password change for promoters.
  if (user.mustChangePassword) return <Navigate to="/change-password" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homePathFor(user)} replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, checking } = useAuth();
  if (checking) return <Loading />;

  return (
    <Routes>
      <Route
        path="/login"
        element={user ? <Navigate to={homePathFor(user)} replace /> : <Login />}
      />
      <Route
        path="/change-password"
        element={
          !user ? <Navigate to="/login" replace /> : <ChangePassword />
        }
      />

      {/* Admin */}
      <Route path="/" element={<Protected roles={["admin"]}><Dashboard /></Protected>} />
      <Route path="/affiliates" element={<Protected roles={["admin"]}><Affiliates /></Protected>} />
      <Route path="/affiliates/:id" element={<Protected roles={["admin"]}><AffiliateDetail /></Protected>} />
      <Route path="/conversions" element={<Protected roles={["admin"]}><Conversions /></Protected>} />
      <Route path="/conversions/:id" element={<Protected roles={["admin"]}><ConversionDetail /></Protected>} />
      <Route path="/products" element={<Protected roles={["admin"]}><Products /></Protected>} />
      <Route path="/promoters" element={<Protected roles={["admin"]}><Promoters /></Protected>} />
      <Route path="/promoters/:id" element={<Protected roles={["admin"]}><PromoterDetail /></Protected>} />

      {/* Promoter */}
      <Route path="/portal" element={<Protected roles={["promoter"]}><PromoterDashboard /></Protected>} />
      <Route path="/portal/commissions" element={<Protected roles={["promoter"]}><PromoterCommissions /></Protected>} />

      <Route path="*" element={<Navigate to={user ? homePathFor(user) : "/login"} replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
